export const CHAT_SELECTED_CHAT_STORAGE_KEY = "muzone.chat.selectedChat";
export const CHAT_NO_SELECTED_CHAT_STORAGE_VALUE = "__muzone_chat_no_selection__";

export const DEFAULT_CHAT_MESSAGE_PAGE_SIZE = 50;
export const MAX_CHAT_MESSAGE_PAGE_SIZE = 200;
export const CHAT_SEARCH_PAGE_SIZE = DEFAULT_CHAT_MESSAGE_PAGE_SIZE;
export const CHAT_SEARCH_RESULT_LIMIT = 30;
export const CHAT_SEARCH_MAX_PAGES = 6;

export const normalizeChatMessagePageLimit = (limit = DEFAULT_CHAT_MESSAGE_PAGE_SIZE) => {
    const numericLimit = Number(limit);
    if (!Number.isFinite(numericLimit) || numericLimit <= 0) {
        return DEFAULT_CHAT_MESSAGE_PAGE_SIZE;
    }
    return Math.min(Math.floor(numericLimit), MAX_CHAT_MESSAGE_PAGE_SIZE);
};
